export const environment = {
  production: false,
  apiUrl: "https://qa-uk-api.equinemedirecord.com/api/v1",
  socketUrl: "https://qa-uk-api.equinemedirecord.com",
  socketPort: ":6001",
  maxImgCount: 5,
  maxImgSize: "10485760", // in bytes
  defaultLanguage: "en",
  languages: [],
  country: "uk",
  availableCountries: {
    ireland: "https://qa-ie-app.equinemedirecord.com",
    uk: "https://qa-uk-app.equinemedirecord.com",
    france: "https://qa-fr-app.equinemedirecord.com",
    usa: "https://qa-us-app.equinemedirecord.com",
    sa: "https://qa-sa-app.equinemedirecord.com",
  },
  stripeKey: "pk_test_37ClOdBt2dkVZ4Vp7wESYQZI00rxaDoF3n",
  quick_treatment: false,
  currency: "GBP",
  showRegionsSelect: true, //only for USA & UK
  ruleBookPdf: null,
  ruleBookKYPdf: null,
  ruleBookCAPdf: null,
  ruleBookBCPdf: null,
  ruleBookBCPdPopup: null,
  ruleBookBC2023Pdf: null,
  ruleBookBC2023PdfPopup: null,
  insurancePdfPopup: "/assets/insurancePdfPopup.pdf",  
  filterRegionForDrugs: false,
  showModalUnvaccinated: true,
  showInTheFoodChainToggle: true,
  dateFormat: "dd/MM/yyyy",
  disableTreatmentEditInstructorNotOwned: false, //If set to true instructor (trainer) can not edit treatments not created by him.
  currentCountry: "uk",
  vaccinationCountries: ["ie", "fr"],
  ruleBookPCPdf: "",
  ruleBookPCPopup: "",
  ruleBookPKPdf: "",
  ruleBookPKPdfPopup: "",
  vaccinationDocumentUrl: "",
  kaynaPlatformId: "906fb694-9f4b-49bb-a775-8ff75aae2198",
  kaynaWidgetUrl: "https://staging-widget.kayna.io/kayna.js"
};



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/environments/environment.ts